import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        uploads: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        uploadMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getUploadsRequest({dispatch}) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveUploads", null);
            } else {
                dispatch("receivingUploads"); // สถานะ กำลังบันทึก

                axios.get('/uploads').then(res => {

                    dispatch("receiveUploads", res.data);
                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receiveUploads", null);
                    })
            }
        },
        loadUploadRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveUpload", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingUpload");
                axios.get('/uploads/' + id).then(res => {
                    dispatch("receiveUpload", res.data);
                })
            }
        },
        updateUploadRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingUpload");

            const formData = new FormData();
            formData.append('file', payload.uploads_url);
            formData.append('uploads_id', payload.uploads_id);
            formData.append('uploads_title_th', payload.uploads_title_th);


            axios.post('/uploads', formData).then(res => {
                dispatch("updateUpload", res.data);
            })

        },
        createUploadRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingUpload");

            const formData = new FormData();
            formData.append('file', payload.uploads_url);
            formData.append('uploads_id', payload.uploads_id);
            formData.append('uploads_title_th', payload.uploads_title_th);

            axios.post('/uploads', formData).then(res => {


                dispatch("receiveUpload", res.data);

            })
        },
        deleteUploadRequest({dispatch}, payload) {

            dispatch("afterDeleteUpload", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingUpload", payload);

            axios.post('/delete_uploads', payload).then(res => {
                dispatch("deleteUpload", {uploads_id: payload.uploads_id, res: res});
            })


        },
        receiveUploads({commit}, payload) {
            commit("RECEIVED_UPLOADS", payload)
        },
        receivingUploads({commit}) {
            commit("RECEIVING_UPLOADS") //call matutions --> state.isReceiving = true;
        },
        receiveUpload({commit}, payload) {
            commit("RECEIVED_UPLOAD", payload)
        },
        receivingUpload({commit}) {
            commit("RECEIVING_UPLOADS") //call matutions --> state.isReceiving = true;
        },
        updateUpload({commit}, payload) {
            commit("UPDATED_UPLOAD", payload)
        },
        updatingUpload({commit}) {
            commit("UPDATING_UPLOAD") //  call matutions --> state.isUpdating = true;
        },
        deleteUpload({commit}, payload) {
            commit("DELETED_UPLOAD", payload)
        },
        deletingUpload({commit}, payload) {
            commit("DELETING_UPLOAD", payload)
        },
        afterDeleteUpload({commit}, payload) {
            commit("AFFTER_DELETED_UPLOAD", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_UPLOADS(state, payload) {
            state.uploads = payload;
            state.isReceiving = false;

        },
        RECEIVING_UPLOADS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_UPLOAD(state, payload) {


            if (payload.uploads_id == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let uploadMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    uploadMessage: (state.uploadMessage == uploadMessage ? uploadMessage + ' ' : uploadMessage),

                });
            } else {
                let uploadMessage = 'บันทึกสำเร็จ! รายการ ' + payload.uploads_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    uploads: [...state.uploads, payload],
                    isReceiving: false,
                    errorMessage: false,
                    uploadMessage: (state.uploadMessage == uploadMessage ? uploadMessage + ' ' : uploadMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_UPLOAD(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_UPLOAD(state, payload) {
            let index = state.uploads.findIndex(p => p.uploads_id === payload.uploads_id);
            let uploadMessage = 'บันทึกสำเร็จ! รายการ ' + payload.uploads_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                uploads: state.uploads.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                uploadMessage: (state.uploadMessage == uploadMessage ? uploadMessage + ' ' : uploadMessage),
            })
        },
        UPDATING_UPLOAD(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_UPLOAD(state, payload) {


            if (payload.uploads_id == undefined || payload.res.data.message == 'Relation') {
                let uploadMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.uploads_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    uploadMessage: (state.uploadMessage == uploadMessage ? uploadMessage + ' ' : uploadMessage),

                });
            } else {
                let indexToDelete = state.uploads.findIndex(p => p.uploads_id === payload.uploads_id);
                let uploads = [...state.uploads];
                uploads.splice(indexToDelete, 1);
                let uploadMessage = 'บันทึกสำเร็จ! รายการ ' + payload.uploads_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    uploads: [...uploads],
                    isDeleting: false,
                    idToDelete: null,
                    uploadMessage: (state.uploadMessage == uploadMessage ? uploadMessage + ' ' : uploadMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_UPLOAD(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.uploads_id;
        },
        AFFTER_DELETED_UPLOAD(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
